import { useEffect, useState } from 'react';
import styled from 'styled-components';
import FlexWrap from '@/components/common/FlexWrap';
import ReceiptImage from '@/components/Receipt/ReceiptImage';
import { StoreReceiptResponse } from '@/types/store.type';
import { IGlobalState } from '@/store';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { reformReceiptData } from '@/utils/receipt.util';
import { ICON_CHEVRON_RIGHT_WHITE } from '@repo/assets';

interface Props {
  data: { data: StoreReceiptResponse; selectedRefund: number };
  onClose: () => void;
}
function ReceiptPreviewModal({ data, onClose }: Props) {
  const { passportNumber } = useAppSelector((state) => state) as IGlobalState;
  const [selectedIndex, setSelectedIndex] = useState(data.selectedRefund || 0);

  useEffect(() => {
    window.addEventListener('popstate', onClose);
    return () => {
      window.removeEventListener('popstate', onClose);
    };
  }, []);

  const countIndex = (operator: '+' | '-') => {
    setSelectedIndex((prev) => {
      if (operator === '-') {
        return prev - 1;
      }
      return prev + 1;
    });
  };

  return (
    <BackContainer
      onClick={() => {
        document.body.style.removeProperty('overflow');
      }}
    >
      {selectedIndex !== 0 && (
        <LeftButton type='button' onClick={() => countIndex('-')}>
          <img src={ICON_CHEVRON_RIGHT_WHITE} alt='before' />
        </LeftButton>
      )}
      {data.data.map((receiptData, index) => {
        if (index === selectedIndex) {
          const newData = reformReceiptData(receiptData, passportNumber!);
          return (
            <ReceiptImage
              onClose={onClose}
              info={newData}
              index={index}
              style={{
                height: '90%',
                overflowY: 'scroll',
              }}
            />
          );
        }
      })}
      {data.data.length - 1 > selectedIndex && (
        <RightButton type='button' onClick={() => countIndex('+')}>
          <img src={ICON_CHEVRON_RIGHT_WHITE} alt='next' />
        </RightButton>
      )}
    </BackContainer>
  );
}

export default ReceiptPreviewModal;

const BackContainer = styled(FlexWrap)`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  margin: 0 auto;
  height: 100%;
  padding: 0 20px;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200;
  @media ${(props) => props.theme.desktop} {
    max-width: 375px;
  }
`;

const LeftButton = styled.button`
  position: absolute;
  left: 0;
  padding: 20px 5px;
  background-color: #00000050;
  img {
    display: block;
    width: 36px;
    transform: rotateY(180deg);
  }
`;

const RightButton = styled.button`
  position: absolute;
  right: 0;
  padding: 20px 5px;
  background-color: #00000050;
  img {
    display: block;
    width: 36px;
  }
`;
